jQuery(function($){
	$('.login-form-link').on('click', function(e){
		e.preventDefault();

		let parentDiv = $(this).closest('.form-body');
		parentDiv.find('.login-form').css('display', 'flex');
		parentDiv.find('.reset-password').hide();
	});

	$('.reset-password-link').on('click', function(e){
		e.preventDefault();
		
		let parentDiv = $(this).closest('.form-body');
		parentDiv.find('.reset-password').css('display', 'flex');
		parentDiv.find('.login-form').hide();
	});
});